<template>
  <div>
    <b-modal ref="my-modal" centered hide-footer :title="'Add Branch'">
        <form v-on:submit.prevent="doSubmitBranch">
            <label>Name *</label>
            <b-form-input :required="true" for-inpuet="name" type="text" name="name" id="name" label="Name" placeholder="Enter name" v-validate="branchValidations.name" :error="errors.first('name')" v-model="branch.name" data-vv-as="name"/><br>
            <label>Ex Change ID *</label>
            <b-form-input :required="true" for-input="exchangeId" type="text" name="exchangeId" id="exchangeId" label="Ex Change Id" placeholder="Enter ex change id" v-validate="branchValidations.exchangeId" :error="errors.first('exchangeId')" v-model="branch.exchangeId" data-vv-as="ex change id"/><br>
            <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.branch.uuid !== null ? 'Update' : 'Submit'}} </b-button>
            <b-button variant="secondary" class="float-left mr-3" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
        </form>
    </b-modal>
  </div>
</template>
<script>
  import Vue from 'vue'
  
  export default {
    data () {
      return {
        apiUrl: {
          branch: window.AppConfig.apiUrl + 'branch',
        },
        type: null,
        branch: {
          uuid: null,
          name: null,
          exchangeId: null
        },
        branchValidations: {
          name: {
              required: true
          },
          exchangeId: {
              required: true
          }
        }
      }
    },
    methods: {
      doSubmitBranch() {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.isLoading = true
            if (this.branch.uuid !== null) {
              let branch = {}
              Object.keys(this.branch).forEach(element => {
                  if (element !== 'uuid') {
                  branch[element] = this.branch[element]
                  }
              })
              this.$http.patch(this.apiUrl.branch + '/' + this.branch.uuid, branch).then(response => {
                  this.isLoading = false
                  this.$store.dispatch('notification/success', 'Branch successfully updated.')
                  this.$emit('getBranch')
                  this.resetData()
                  this.hideModal()
              }).catch(error => {
                  this.isLoading = false
                  this.$store.dispatch('notification/error', error)
              })
            } else {
              this.$http.post(this.apiUrl.branch, this.branch).then(response => {
                  this.isLoading = false
                  this.$store.dispatch('notification/success', 'Branch successfully added.')
                  this.hideModal()
                  this.resetData()
                  this.$emit('getBranch')
              }).catch(error => {
                  this.isLoading = false
                  this.$store.dispatch('notification/error', error)
              })
            }
          }
        })
      },
      resetData () {
          this.branch.uuid = null
          this.branch.name = null
          this.branch.exchangeId = null
          this.$validator.reset()
      },
      showModal() {
          this.branch.name = null
          this.branch.exchangeId = null
          this.branch.uuid = null
          this.$validator.reset();
          this.$refs['my-modal'].show()
      },
      hideModal () {
          this.resetData()
          this.$refs['my-modal'].hide()
      }
    }
  }
</script>